import React, { useState } from "react";
import { Button, Container, ListGroup } from "react-bootstrap";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import AddAreaModal from "./components/AddAreaModal";
import AreaItem from "./components/AreaItem";
import { areasApi as api } from "./api/Areas.api";
import ActivityLoader from "activity/componenets/ActivityLoader";

const AreasScreen = () => {
  const { data, isFetching } = api.useFetchAreasQuery({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [areaToDelete, setAreaToDelete] = useState<any>(null);

  if (isFetching) return <ActivityLoader />;

  return (
    <Container className="my-5">
      <section className="d-flex justify-content-between align-items-center">
        <h4>Area List</h4>
        <Button
          className="btn btn-primary btn-flat"
          onClick={() => setShowAddModal(true)}
        >
          + Add Area
        </Button>
      </section>

      <ListGroup className="mt-3">
        {data?.result?.map((area) => (
          <AreaItem
            key={area.id}
            area={area}
            onDelete={() => setAreaToDelete(area)}
          />
        ))}
      </ListGroup>

      <AddAreaModal show={showAddModal} onHide={() => setShowAddModal(false)} />

      {areaToDelete && (
        <DeleteConfirmationModal
          show={!!areaToDelete}
          area={areaToDelete}
          onHide={() => setAreaToDelete(null)}
        />
      )}
    </Container>
  );
};

export default AreasScreen;
